import { useContext, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { SetupContext } from "../../pages/SetupPage/SetupContext"
import BudgetForm from "./BudgetForm"
import { Budget } from "./budgetModel"
import { useBudget, useUpdateBudget } from "./budgetQueries"
import UpdateItemPricingModal from "./UpdateItemPricingModal"

const BudgetFormWrapper = () => {
  const params = useParams()
  const year = parseInt(params.year ?? '0')
  const { saveCounter, markDirty, markClean } = useContext(SetupContext)
  const [budgetsSaveCounter, setBudgetsSaveCounter] = useState(0)
  const [modalOpen, setModalOpen] = useState(false)
  const [updatedBudget, setUpdatedBudget] = useState<Budget[] | undefined>()

  const budgetsQuery = useBudget(year)
  const updateBudgetMutation = useUpdateBudget(() => setModalOpen(false))

  const budgets = budgetsQuery.data?.filter(b => b.year === year)

  useEffect(() => {
    setBudgetsSaveCounter(x => x + 1)
    markClean()
  }, [budgetsQuery.data])

  useEffect(() => {
    if (updatedBudget) {
      setModalOpen(true)
    }
  }, [saveCounter])

  const handleModalConfirm = (updateJobs: boolean) => {
    updateBudgetMutation.mutate({ budgets: updatedBudget!, updateJobs })
  }

  const handleModalCancel = () => {
    setModalOpen(false)
  }

  if (!budgetsQuery.data || budgetsQuery.data.length === 0 || !params.year) {
    return <></>
  }

  const handleChange = (budgets: Budget[]) => {
    setUpdatedBudget(budgets)
    markDirty()
  }

  return <>
    <BudgetForm
      budgets={budgets}
      onChange={handleChange}
      saveCounter={budgetsSaveCounter}
    />
    <UpdateItemPricingModal
      open={modalOpen}
      loading={updateBudgetMutation.isLoading}
      onConfirm={handleModalConfirm}
      onCancel={handleModalCancel}
    />
  </>
}

export default BudgetFormWrapper
